import { FilterDropdownProps } from 'antd/lib/table/interface';
import React from 'react';
import CustomFilterDropdownIcon from '../../shared/components/filterDropdownComponent/CustomFilterDropdownIcon';
import FilterDropdownComponentForAbha from '../../shared/components/filterDropdownComponent/FilterDropdownComponentForAbha';
import { getDateWithTime } from '../../utils/dateTimeUtils';
import AbdmHome from './AbdmHome';
import ConcentList from './ConcentList/ConcentList';
import ConcentDetail from './Detail/ConcentDetail';
import {
  CareContextDetails,
  DeepLinkUserInfo, EnterAbha, EnterOTP, FinalPage, FinalPageForClaimDetail, FinalPageWithoutAbha,
  SelectAuthModes, UploadFiles, UploadFilesWithoutAbha,
  UserInfo,
} from './LinkDocsWithAbha/AbhaChildComponents';
import RecordsList from './RecordsList/RecordsList';
export const NOTREQUIRED = 'N/A';
export const TABLE_COLS = [{
  title: 'Date',
  dataIndex: 'date',
 },
 {
  title: 'Observation',
  dataIndex: 'observ',
  },
  {
   title: 'Value',
   dataIndex: 'val',
  },
  {
    title: 'Status and Interpretation',
  dataIndex: 'status',
}];

export const TEST = 'test';
export const isValidationEnabled = process.env.REACT_APP_ABDM_CONCENT_ALLOW_VALIDATION === 'true';

export const ABDM_NESTED_ROUTES = [
  {
    tabName: 'Concent detail',
    routeName: 'concent-detail/:data',
    Component: ConcentDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Concent List',
    routeName: 'concent-list',
    Component: ConcentList,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Records List',
    routeName: 'records-list',
    Component: RecordsList,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Register HIU',
    routeName: '/',
    Component: AbdmHome,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export function getColumnSearchDropdownAbha(extraParams: any): any {
  return ({
    filterDropdown: (props: FilterDropdownProps): any => {
      return (<FilterDropdownComponentForAbha {...props} {...extraParams} />);
    },
  });
}

export const IP_DROPDOWN_SEARCH_INPUT_TYPES = {
  TEXT: 'TEXT',
  AMOUNT: 'AMOUNT',
  DATE_RANGE: 'DATE_RANGE',
  MULTISELECT_CHECKBOX: 'MULTISELECT_CHECKBOX',
  MULTISELECT_DROPDOWN: 'MULTISELECT_DROPDOWN',
};
export const CONSENT_LIST_COLS = [
  {
    title: 'Patient Name',
    dataIndex: 'patientName',
    filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientName" />,
    ...getColumnSearchDropdownAbha({
      filterKey: 'patientName',
      searchFilterKey : 'PatientName',
      inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
      placeholder: 'Search Patient Name',
    }),
  },
  {
    title: 'ABHA Address',
    dataIndex: 'abhaAddress',
    filterIcon: (): any => <CustomFilterDropdownIcon filterKey="abhaAddress" />,
    ...getColumnSearchDropdownAbha({
      filterKey: 'abhaAddress',
      searchFilterKey : 'PatientAbha',
      inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
      placeholder: 'Search ABHA Address',
    }),
  },
  {
    title: 'Request Status',
    dataIndex: 'consentStatus',
  },
  {
    title: 'Consent Created On',
    dataIndex: 'requestTime',
    render: (requestTime: any): any => getDateWithTime(requestTime),
  },
  {
    title: 'Consent Granted On',
    dataIndex: 'responseTime',
    render: (responseTime: any): any => getDateWithTime(responseTime),
  },
  {
    title: 'Consent Expiry On',
    dataIndex: 'expiryDate',
    render: (expiryDate: any): any => getDateWithTime(expiryDate),
  },
];

export const PURPOSE_OF_REQUEST: any[] = [
  {
    value: 'CAREMGT',
    label: 'Care Management',
  },

  {
    value: 'BTG',
    label: 'Break the Glass (Medical Emergency)',
  },
  {
    value: 'PATRQT',
    label: 'Self Requested',
  },
  {
    value: 'PUBHLTH',
    label: 'Public Health',
  },
  {
    value: 'DSRCH',
    label: 'Disease Specific Health Research',
  },
];

export const HEALTH_INFO_TYPE = [
  {
    value: 'DiagnosticReport',
    label: 'Diagnostic Report',
  },
  {
    value: 'Prescription',
    label: 'Prescription',
  },
  {
    value: 'OPConsultation',
    label: 'OP Consultation Note',
  },
  {
    value: 'WellnessRecord',
    label: 'Wellness Record',
  },
  {
    value: 'DischargeSummary',
    label: 'Discharge Summary',
  },
  {
    value: 'ImmunizationRecord',
    label: 'Immunization Record',
  },
  {
    value: 'HealthDocumentRecord',
    label: 'Health Document Record',
  },
];

export const LINK_RECORDS_COMPONENTS = [
  {
    title: 'Enter ABHA Number or ABHA Address',
    component: EnterAbha,
  },
  {
    title: 'Add care context details',
    component: CareContextDetails,
    backFn: true,
  },
  {
    title: 'Upload the documents to be linked',
    component:  UploadFiles,
    backFn: true,
  },
  {
    title: 'Select preferred auth mode',
    component: SelectAuthModes,
    backFn: true,
  },
  {
    title: 'Validate profile',
    component: EnterOTP,
    backFn: true,
  },
  {
    title: 'Verify user information',
    component: UserInfo,
    backFn: true,
  },
  {
    component: FinalPage,
  },
];
export const LINK_RECORDS_COMPONENTS_CLAIMS_DATA = [
  {
    title: 'Enter ABHA Number or ABHA Address',
    component: EnterAbha,
  },
  {
    title: 'Select preferred auth mode',
    component: SelectAuthModes,
    backFn: true,
  },
  {
    title: 'Validate profile',
    component: EnterOTP,
    backFn: true,
  },
  {
    title: 'Verify user information',
    component: UserInfo,
    backFn: true,
  },
  {
    component: FinalPageForClaimDetail,
  },
];

export const EDIT_RECORD = [
  {
    title: 'Upload the documents to be linked',
    component: UploadFiles,
    backFn: false,
  },
  {
    component: FinalPage,
  },
];

export const LINK_RECORDS_WITHOUT_ABHA = [
  {
    title: 'Enter ABHA Number',
    component: EnterAbha,
  },
  {
    title: 'Add care context details',
    component: CareContextDetails,
    backFn: true,
  },
  {
    title: 'Enter user details',
    component: DeepLinkUserInfo,
  },
  {
    title: 'Upload the documents to be linked',
    component: UploadFilesWithoutAbha,
  },
  {
    component: FinalPageWithoutAbha,
  },
];

export const LINK_RECORDS_WITHOUT_ABHA_CLAIM_DATA = [
  {
    title: 'Enter ABHA Number',
    component: EnterAbha,
  },
  {
    title: 'Enter user details',
    component: DeepLinkUserInfo,
  },
  {
    component: FinalPageWithoutAbha,
  },
];

export const GENDER_LIST = [
  {
    label: 'Male',
    value: 'M',
  },
  {
    label: 'Female',
    value: 'F',
  },
  {
    label: 'Others',
    value: 'O',
  },
  {
    label: 'Undisclosed',
    value: 'U',
  },
];

export const ABDM_ENDPOINTS = {'getHipHiuDetails': 'api/HIP/GetHipHiuDetails', 'consentDetail' : 'api/Hiu/consents-detail'};
